<span (click)="toggleIcon()">
    <span class="c-icon c-icon--main">
        <i class="fa fa-compress" aria-hidden="true" [ngClass]="{'fa-compress': !isToggleON, 'fa-expand' : isToggleON}"></i>
    </span>
</span>
